import { render, staticRenderFns } from "./AhorraConTuTaxi.vue?vue&type=template&id=2c4dd8ec&scoped=true&"
import script from "./AhorraConTuTaxi.vue?vue&type=script&lang=js&"
export * from "./AhorraConTuTaxi.vue?vue&type=script&lang=js&"
import style0 from "./AhorraConTuTaxi.vue?vue&type=style&index=0&id=2c4dd8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4dd8ec",
  null
  
)

export default component.exports